export default {
    methods: {
        isMobile() {
            return this.isVerysmall() || this.isSmall();
        },
        isTablet() {
            return this.isMedium() || this.isLarge();
        },
        isVerysmall () {
            return this.$mq === 'verysmall';
        },
        isSmall () {
            return this.$mq === 'small';
        },
        isMedium() {
            return this.$mq === 'medium';
        },
        isLarge () {
            return this.$mq === 'large';
        },
        isVerylarge() {
            return this.$mq === 'verylarge';
        },
        isDesktop() {
            return this.$mq === 'desktop';
        }
    }
  };